import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs/internal/Observable';

import { OverviewSandbox, SearchService } from '@mediahaven/shared';
import {
    ApiFragment,
    DisplayMode,
    FragmentId,
    MediaObjectId,
    RecordId,
    RecordRestrictions,
    Restriction,
    TernaryLogic,
    ZoneRestrictions
} from '@stylehaven/components';
import { distinctUntilChanged, map } from 'rxjs/operators';

@Injectable()
export abstract class PortalOverviewSandbox extends OverviewSandbox {
    protected readonly searchService: SearchService = inject(SearchService);
    protected readonly zoneRestrictions: ZoneRestrictions = inject(ZoneRestrictions);

    // #region Record data
    public getRecord(
        recordId: RecordId | FragmentId | MediaObjectId,
        trackConsult: boolean = false
    ): Observable<ApiFragment> {
        return this.searchService.getRecord(recordId, { trackConsult });
    }

    public abstract getRestrictions(...args: any): Observable<Restriction>;

    protected getGeolocationRestriction(): Observable<Restriction> {
        return this.getUrlQueryState().pipe(
            map(state => state.view === DisplayMode.MAP),
            distinctUntilChanged(),
            map(isMap => RecordRestrictions.geolocationRestriction(isMap ? TernaryLogic.true : TernaryLogic.both))
        );
    }

    // #endregion

    public translate(token: string, params?: object | undefined): string {
        return this.translateService.instant(token, params);
    }
}
